import React from 'react';
import { BringzzIcon, BringzzText } from "@bringzz/components";
import { parseNotificationContent, formatNotificationDate, getNotificationIcon } from '../utils';

const NotificationItem = ({
    notification,
    uniqueKey,
    isUnread,
    markingAsRead,
    deletingNotifications,
    onNotificationClick,
    onDeleteNotification
}) => {
    const parsedContent = parseNotificationContent(notification.content || notification.message || '{}');

    return (
        <div
            key={uniqueKey}
            className={`relative bg-white rounded-lg shadow-sm border border-gray-200 p-4 cursor-pointer transition-all hover:shadow-md ${
                isUnread ? 'border-l-4 border-l-magic-lilac' : ''
            }`}
            onClick={() => onNotificationClick(notification)}
        >
            <div className="flex items-start justify-between">
                {/* Left section: Icon and content */}
                <div className="flex items-start space-x-3 flex-1">
                    <div className={`p-2 rounded-full ${isUnread ? 'bg-magic-lilac bg-opacity-20' : 'bg-gray-100'}`}>
                        {markingAsRead[notification.id] ? (
                            <BringzzIcon
                                size="20"
                                icon="IconSpinner"
                                folder="LineIcons"
                                className="animate-spin text-magic-lilac"
                            />
                        ) : (
                            <BringzzIcon
                                size="20"
                                icon={getNotificationIcon(notification.notification_type)}
                                folder="LineIcons"
                                className={isUnread ? 'text-magic-lilac' : 'text-gray-600'}
                            />
                        )}
                    </div>

                    <div className="flex-1 min-w-0">
                        <div className="flex items-center justify-between mb-1">
                            <BringzzText
                                tag="h4"
                                className={`font-semibold text-sm ${isUnread ? 'text-black' : 'text-gray-800'}`}
                            >
                                {notification.title}
                            </BringzzText>
                            {isUnread && (
                                <div className="w-2 h-2 bg-magic-lilac rounded-full ml-2"></div>
                            )}
                        </div>

                        {/* Order details for ORDER_REQUEST type */}
                        {notification.notification_type === 'ORDER_REQUEST' && parsedContent.consumer && (
                            <div className="mb-2">
                                <BringzzText className="text-xs text-gray-600 mb-1">
                                    Order from {parsedContent.consumer} • €{parsedContent.total}
                                </BringzzText>
                                {parsedContent.items && parsedContent.items.length > 0 && (
                                    <div className="text-xs text-gray-500">
                                        {parsedContent.items.length} item{parsedContent.items.length > 1 ? 's' : ''} •
                                        {parsedContent.items.slice(0, 2).map(item => item.name || 'Unknown item').join(', ')}
                                        {parsedContent.items.length > 2 && ` +${parsedContent.items.length - 2} more`}
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Generic content for other notification types */}
                        {notification.notification_type !== 'ORDER_REQUEST' && (
                            <BringzzText className="text-xs text-gray-600 mb-2 line-clamp-2">
                                {typeof parsedContent === 'string' ? parsedContent : parsedContent.message || 'No content'}
                            </BringzzText>
                        )}

                        <BringzzText className="text-xs text-gray-400">
                            {formatNotificationDate(notification.created)}
                        </BringzzText>
                    </div>
                </div>

                {/* Right section: Delete button */}
                <div className="ml-2">
                    {deletingNotifications[notification.id] ? (
                        <BringzzIcon
                            size="16"
                            icon="IconSpinner"
                            folder="LineIcons"
                            className="animate-spin text-gray-400"
                        />
                    ) : (
                        <BringzzIcon
                            size="16"
                            icon="IconClose"
                            folder="LineIcons"
                            className="cursor-pointer text-gray-400 hover:text-red-500 transition-colors"
                            onClick={(e) => {
                                e.stopPropagation();
                                onDeleteNotification(notification.id);
                            }}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default NotificationItem;
